import { $locationShape } from 'src/api/decoders/location_shape'
import {
  $conversationCreate,
  $conversationMessages,
  $conversationResponse,
  $conversations,
  $messageCreate
} from 'src/api/decoders/mailbox'
import { $oauth2Credentials } from 'src/api/decoders/oauth2'
import { $profile } from 'src/api/decoders/profile'
import { $profileTags } from 'src/api/decoders/tags'

const $noop = <Model>(a: Model) => a

// To avoid duplications in decoders
export {
  $conversationCreate,
  $conversationMessages, $conversationResponse,
  $conversations,
  $locationShape,
  $messageCreate,
  $noop,
  $oauth2Credentials,
  $profile,
  $profileTags
}
